export const EXPANDED_DRAWER_WIDTH: number = 240;
export const COLLAPSED_DRAWER_WIDTH = 75; // Define a collapsed width for the
export const NOTIFICATION_MOCKS = require('./notificationData.json');
